import UserInterfaceLock from '@mds/icons/Lock';
import { Box, Chip as TextLabel, Typography } from '@mui/material';
import React from 'react';

import { ChannelTypes } from '../../shared/types';

interface ChannelLabelProps {
    type: ChannelTypes;
    withDescription?: boolean;
}
export const ChannelLabel = ({ type, withDescription }: ChannelLabelProps) => {
    const isPremium = type === ChannelTypes.premium;
    const color = isPremium ? 'secondary' : 'default';
    const label =
        type === ChannelTypes.freeClosed
            ? 'free - closed'
            : type === ChannelTypes.freeOpen
              ? 'free - open'
              : 'premium';
    return (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <TextLabel
                color={color}
                size="small"
                label={label}
                variant={isPremium ? 'outlined' : 'solid'}
            />
            {type === ChannelTypes.freeClosed && (
                <UserInterfaceLock fontSize="small" />
            )}
            {withDescription && (
                <Typography>
                    {type === ChannelTypes.premium ? (
                        <>
                            Insights users have to pay to become subscribers and
                            gain full access to the channel.
                        </>
                    ) : type === ChannelTypes.freeClosed ? (
                        <>
                            This channel is <strong>closed</strong>. Insights
                            users have to request access to become subscribers
                            and gain full access to the channel.
                        </>
                    ) : (
                        <>
                            This channel is <strong>open to everyone</strong>.
                            All Insights user can access the channel and read
                            your articles.
                        </>
                    )}
                </Typography>
            )}
        </Box>
    );
};
